<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const colorKeyVariants = cva('group/color-key flex text-xs', {
  variants: {
    layout: {
      stacked: 'gap-2',
      inline: 'gap-1',
      justify: 'gap-1',
      hero: 'gap-2',
    },
  },
  defaultVariants: {
    layout: 'stacked',
  },
})

const colorKeyContentVariants = cva('flex min-w-0', {
  variants: {
    layout: {
      stacked: 'w-full flex-col justify-center gap-1',
      inline: 'grow items-center gap-1',
      justify: 'grow items-center justify-between gap-4',
      hero: 'w-full flex-col gap-1',
    },
  },
  defaultVariants: {
    layout: 'stacked',
  },
})

export type ColorKeyVariants = VariantProps<typeof colorKeyVariants>
</script>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  color: string
  layout?: ColorKeyVariants['layout']
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="color-key"
    :data-layout="layout ?? 'stacked'"
    :class="cn(colorKeyVariants({ layout }), props.class)"
    :style="{ '--key-color': color }"
  >
    <span aria-hidden="true" class="w-1 shrink-0 rounded-full bg-(--key-color)" />
    <div :class="colorKeyContentVariants({ layout })">
      <slot />
    </div>
  </div>
</template>
